import "./style.scss";
import * as React from "react";
import { Popover } from "antd";
import { FlyerItem, FlyerPage } from "../types";
const d3 = require("d3-format");

export interface FlyerItemRectangleProps {
  item: FlyerItem;
  page: FlyerPage;
  scale: number;
  metric: string;
  colour: string;
}

const tooltipBaseStyle: any = {
  position: "absolute",
  width: 100,
  height: 100,
  backgroundColor: "black",
  top: 0,
  left: 0
};

export class FlyerItemRectangle extends React.Component<
  FlyerItemRectangleProps,
  any
> {
  constructor() {
    super();
    this.state = {
      hover: false,
      mouseX: 0,
      mouseY: 0
    };
  }

  handleMouseMove = (e: any) => {
    this.setState({ mouseX: e.clientX, mouseY: e.clientY });
  };

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const { page, item, scale } = this.props;
    const width =
      item.orig_flyer_item_coordinate_right -
      item.orig_flyer_item_coordinate_left;
    const height =
      item.orig_flyer_item_coordinate_top -
      item.orig_flyer_item_coordinate_bottom;
    const x = item.orig_flyer_item_coordinate_left - page.left;
    const dataName = item.orig_flyer_item_name;
    const dataMetric = this.props.metric;
    const dataValue = item[this.props.metric];

    // Make coordinate positive to work with SVG
    const y = -1 * item.orig_flyer_item_coordinate_top;

    // Hack to set hover colours
    const darkColour = this.props.colour.replace(", 50%", ", 10%");

    // Set tooltip vars
    const tooltipDisplay = this.state.hover ? "inline-block" : "none";
    const tooltipX = this.state.mouseX + 5;
    const tooltipY = this.state.mouseY - 70;

    // Tooltip for this rectangel is hidden, and a div is coloured/positioned accordingly.
    return (
      <div className="item-rectangle">
        <div
          className="chart-tooltip"
          style={{
            left: tooltipX,
            top: tooltipY,
            display: tooltipDisplay,
            color: "#5D6368"
          }}
        >
          <span className="tooltip-title">{dataName}</span>
          <ul>
            <li>
              <span className="tooltip-info metric">
                {dataMetric.split("_").join(" ").toUpperCase()}
              </span>
              &nbsp;&nbsp;
              <span className="tooltip-info value">
                {d3.format(",")(dataValue)}
              </span>
            </li>
          </ul>
        </div>
        <div
          style={{
            position: "absolute",
            left: x * scale,
            top: y * scale,
            height: height * scale,
            width: width * scale,
            overflow: "visible",
            borderColor: darkColour,
            borderWidth: this.state.hover ? "3px" : "0px",
            borderStyle: "solid",
            backgroundColor: this.props.colour
          }}
          onMouseOver={this.handleMouseEnter}
          onMouseOut={this.handleMouseLeave}
          onMouseMove={this.handleMouseMove}
        ></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/FlyerItemRectangle/index.tsx